'use client';

import { c as _c } from "react/compiler-runtime";
import LikeButton from '@/app/[locale]/(worlds)/[roomId]/components/LikeButton';
import SaveButton from '@/app/[locale]/(worlds)/[roomId]/components/SaveButton';
import SharePopoverButton from '@/app/[locale]/(worlds)/[roomId]/components/SharePopoverButton';
import WorldMoreActionButton from '@/app/[locale]/(worlds)/[roomId]/components/WorldMoreActionButton';
import { BTN_GLASS_PILL } from '@/constants/action-buttons';
type WorldMobileActionButtonsProps = {
  onReport: () => void;
};
export default function WorldMobileActionButtons(t0) {
  const $ = _c(5);
  const {
    onReport
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LikeButton className={BTN_GLASS_PILL} iconClassName="[&>path]:fill-vive-primary-20 size-5 shrink-0" labelClassName="text-vive-primary-20 text-[14px] leading-[18px] font-semibold tracking-[0.15px]" size="custom" showCount={true} />;
    t2 = <SharePopoverButton className={BTN_GLASS_PILL} iconClassName="size-5" size="custom" />;
    t3 = <SaveButton className={BTN_GLASS_PILL} iconClassName="size-5" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onReport) {
    t4 = <div className="flex h-9 w-full items-center justify-center gap-1 rounded-b-lg">{t1}{t2}{t3}<WorldMoreActionButton className={BTN_GLASS_PILL} handleReport={onReport} iconClassName="size-5" size="custom" /></div>;
    $[3] = onReport;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}